// Utility function for functional components that need feature flags with connect
export const getFeatureFlagFromStore = (flagKey, featuresStore) => {
    return {
        isEnabled: featuresStore.features[flagKey] || false,
        isLoading: featuresStore.loading,
        error: featuresStore.error,
    };
};
